import PropTypes from 'prop-types';
import React from 'react';
import Loading from '../../../components/Loading';
import HotelDetailView from './HotelDetailView';

class HotelDetail extends React.Component {
  componentWillMount() {
    if (this.props.needFetch) {
      this.props.requestHotel(this.props.id);
    }
    // if id are different request new hotel detail
    if (this.props.hotel) {
      if (this.props.hotel.id !== this.props.id) {
        this.props.requestHotel(this.props.id);
      }
    }
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.id !== nextProps.id) {
      nextProps.requestHotel(this.props.id);
    }
  }
  render() {
    if (this.props.needFetch || this.props.isFetching) {
      return <Loading />;
    }
    return (
      <HotelDetailView
        hotel={this.props.hotel}
        editHotel={this.props.editHotel}
        editHotelFeatures={this.props.editHotelFeatures}
        addHotelContact={this.props.addHotelContact}
        removeHotelContact={this.props.removeHotelContact}
        editHotelPhoto={this.props.editHotelPhoto}
        addHotelPhoto={this.props.addHotelPhoto}
        removeHotelPhoto={this.props.removeHotelPhoto}
        sortHotelPhotos={this.props.sortHotelPhotos}
      />
    );
  }
}

HotelDetail.propTypes = {
  id: PropTypes.string.isRequired,
  hotel: PropTypes.object.isRequired,
  isFetching: PropTypes.bool.isRequired,
  needFetch: PropTypes.bool.isRequired,
  hasError: PropTypes.bool.isRequired,
  requestHotel: PropTypes.func.isRequired,
  editHotel: PropTypes.func.isRequired,
  editHotelFeatures: PropTypes.func.isRequired,
  addHotelContact: PropTypes.func.isRequired,
  removeHotelContact: PropTypes.func.isRequired,
  editHotelPhoto: PropTypes.func.isRequired,
  addHotelPhoto: PropTypes.func.isRequired,
  removeHotelPhoto: PropTypes.func.isRequired,
  sortHotelPhotos: PropTypes.func.isRequired,
};

export default HotelDetail;



// WEBPACK FOOTER //
// src/routes/hotels/components/HotelDetail.js